/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  SignatureChecker,
  SignatureCheckerInterface,
} from "../../../../../@gnosis-guild/zodiac-core/contracts/signature/SignatureChecker";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "moduleTxHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class SignatureChecker__factory {
  static readonly abi = _abi;
  static createInterface(): SignatureCheckerInterface {
    return new Interface(_abi) as SignatureCheckerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): SignatureChecker {
    return new Contract(address, _abi, runner) as unknown as SignatureChecker;
  }
}
